<template>
  <div class="page" id="page-aboutus">

    <div class="section-header">
      <div class="container">
        <h1>위치안내</h1>
      </div>
    </div>

    <div class="section-body" id="location">
      <div class="container">
        <div class="mapContainer">
          <vue-daum-map
            :appKey="appKey"
            :center.sync="center"
            :level.sync="level"
            :mapTypeId="mapTypeId"
            :libraries="libraries"
            @load="onLoad"
            @center_changed=""
            @zoom_start=""
            @zoom_changed=""
            @bounds_changed=""
            @click=""
            @dblclick=""
            @rightclick=""
            @mousemove=""
            @dragstart=""
            @drag=""
            @dragend=""
            @idle=""
            @tilesloaded=""
            @maptypeid_changed=""
            style="width:100%;height:100%;">
          </vue-daum-map>
        </div>
        <div class="section-information">
          <ul>
            <li>
              <p>주소</p>
              서울시 영등포구 국제금융로 2길 37 에스트레뉴 27층 2703호 <span style="margin-left:110px;">(우) 07327</span>
            </li>
            <li>
              <p>전화번호</p>
              1668-1100
            </li>
            <li>
              <p>팩스번호</p>
              02-6276-6999
            </li>
            <li>
              <p>홈페이지</p>
              www.insunetfc.com
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

/*
네이티브 앱 키
74a1f7473a4f2293aa5feb694c58aec7
REST API 키
f4b27aa23ba6990845ae3032764cab78
JavaScript 키
3c1627f639fce8f05fa1bbb2847d30f5
Admin 키
44d8010173c61b3cbb211894075af494
*/


import VueDaumMap from 'vue-daum-map';

export default {
  components: {
    VueDaumMap
  },

  data(){
    return {
      appKey: '08dc2139ddc671aa81af4be49eb4cae0', // 테스트용 appkey
      center: { lat:37.523158, lng:126.924247 }, // 지도의 중심 좌표
      // 37.5204906,126.9285833
      level: 3, // 지도의 레벨(확대, 축소 정도),
      mapTypeId: VueDaumMap.MapTypeId.NORMAL, // 맵 타입
      libraries: ['drawing'], // 추가로 불러올 라이브러리
      map: null // 지도 객체. 지도가 로드되면 할당됨.
    }
  },
  methods: {
    onLoad (map) {
      this.map = map;
      new kakao.maps.Marker({
        position: new kakao.maps.LatLng(37.523158, 126.924247),
        position: map.getCenter(),
        map: map
      });
    }
  }
}
</script>
